import React, { useState, useEffect } from 'react';
import './Images.css';
import img1 from '../Assets/2b6778fb-bb1d-4a56-9495-070d29dbe2cc.png';
import img2 from '../Assets/37701ed8-7b9b-41db-9f8a-44570647c971.png';
import { useNavigate } from 'react-router-dom';

function Image() {
  const [gallery, setGallery] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const data = [
      {
        id: 1,
        url: `${img1}`,
      },
      {
        id: 2,
        url: 'https://cdn-icons-png.freepik.com/512/3033/3033314.png',
      },
      {
        id: 3,
        url: `${img2}`,
      },
    ];
    setGallery(data);
  }, []);

  const handleClick = (id) => {
  switch(id) {
    case 1:
      navigate('/details1');
      break;
    case 2:
      navigate('/details2');
      break;
    case 3:
      navigate('/details3');
      break;
    default:
      break;
  }
};


  return (
    <div>
    
      <div className="imgrids">
        {gallery.map((item) => (
          <div className="imcard" key={item.id} onClick={() => handleClick(item.id)}>
            <img src={item.url} alt={`img-${item.id}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Image;
